module.exports = __webpack_public_path__ + "img/products-section-bg.5f6a7c2f.svg";